import React, { useState } from 'react';
import { RolesUser } from 'shared/enums';
import { TItemsTab } from 'shared/types/types';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { uiModel } from 'entities/ui';
import { configTabs } from 'shared/helpers/utils';
import { Button, Tabs } from 'antd';
import { useTabsNavigate } from 'shared/hooks';
import style from './index.module.scss';
import FaqCategories from './faqCategories/FaqCategories';
import FaqUnpublicated from './faqUnpublicated/FaqUnpublicated';
import FaqPublicated from './faqPublicated/FaqPublicated';
import CreateCategoryDrawer from './createCategory/CreateCategoryDrawer';

const allRoles = [
  RolesUser.HRDirector,
  RolesUser.Consultant,
  RolesUser.Employee,
  RolesUser.FirstLine,
  RolesUser.SecondLine,
];

const itemsTab: TItemsTab = [
  {
    label: 'Опубликованное',
    key: 'publicated',
    children: <FaqPublicated />,
    role: allRoles,
  },
  {
    label: 'Неопубликованное',
    key: 'unpublicated',
    children: <FaqUnpublicated />,
    role: allRoles,
  },
  {
    label: 'Категории',
    key: 'categories',
    children: <FaqCategories />,
    role: allRoles,
  },
];
const FAQ = () => {
  const [activeTab, handler] = useTabsNavigate('poll', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tab = useAppSelector(uiModel.Tabs.selectors.selectTabs);
  const tabPane = configTabs(role, itemsTab);
  const { isCategoryTab } = useAppSelector(state => state.entities.faq.category);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const setInitialTab = (tab: string) => {
    const exist = itemsTab.every(elem => elem.key !== tab);
    if (!exist) {
      return tab;
    }
    return 'publicated';
  };

  const onDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      <div className={style.actions}>
        <h3 style={{ width: '100%' }}>Часто задаваемые вопросы</h3>
        {!isCategoryTab ? (
          <Link to={'/faq/create'}>
            <Button type="primary">+ Добавить вопрос</Button>
          </Link>
        ) : (
          <div className={style['category-button']}>
            <Button
              type="primary"
              onClick={() => {
                setDrawerOpen(true);
              }}
            >
              + Добавить категорию
            </Button>
            <CreateCategoryDrawer onClose={onDrawerClose} open={drawerOpen} />
          </div>
        )}
      </div>

      <div className={style.wrap}>
        {/* To do: задать роли! */}
        {role && (
          <Tabs activeKey={setInitialTab(activeTab)} onChange={handler} destroyInactiveTabPane items={tabPane}></Tabs>
        )}
      </div>
    </>
  );
};

export default FAQ;
